export const ru = {
    expenses_for_period: 'Расходы',
    preliminary_data: 'До окончания периода данные предварительные',
    option_year: 'за год',
    option_months_6: 'за 6 месяцев',
    option_months_3: 'за 3 месяца',
};
